import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { PublicOnlyRoute } from '../components/PublicOnlyRoute';
import { AttemptAccessRoute } from '../components/AttemptAccessRoute';
import { LandingPage } from '../pages/LandingPage';
import { TryFreePage } from '../pages/TryFreePage';
import { RegisterPage } from '../pages/RegisterPage';
import { LoginPage } from '../pages/LoginPage';
import { PasswordResetRequestPage } from '../pages/PasswordResetRequestPage';
import { PasswordResetConfirmPage } from '../pages/PasswordResetConfirmPage';
import { VerifyEmailPage } from '../pages/VerifyEmailPage';
import { AuthCallbackPage } from '../pages/AuthCallbackPage';
import { AboutPage } from '../pages/AboutPage';
import { TermsPage } from '../pages/TermsPage';
import PrivacyPage from '../pages/PrivacyPage';
import CookiesPage from '../pages/CookiesPage';
import { ContactPage } from '../pages/ContactPage';
import { CheckoutPage } from '../pages/CheckoutPage';
import { PaymentSuccessPage } from '../pages/PaymentSuccessPage';
import { PaymentFailedPage } from '../pages/PaymentFailedPage';
import { PassSuccessPage } from '../pages/PassSuccessPage';
import { SubscriptionPage } from '../pages/SubscriptionPage';
import { DashboardPage } from '../pages/DashboardPage';
import { ProfilePage } from '../pages/ProfilePage';
import { PricingPage } from '../pages/PricingPage';
import { ExamSelectionPage } from '../pages/ExamSelectionPage';
import { ExamHistoryPage } from '../pages/ExamHistoryPage';
import { PreExamSetupPage } from '../pages/PreExamSetupPage';
import { ReadingExamPage } from '../pages/ReadingExamPage';
import { ListeningExamPage } from '../pages/ListeningExamPage';
import { KnmExamPage } from '../pages/KnmExamPage';
import { WritingExamPage } from '../pages/WritingExamPage';
import { SpeakingExamPage } from '../pages/SpeakingExamPage';
import { ResultsPage } from '../pages/ResultsPage';
import { AnswerReviewPage } from '../pages/AnswerReviewPage';
import { NotFoundPage } from '../pages/NotFoundPage';
import AccessibilityPage from '../pages/AccessibilityPage';

// Scroll to top on route change
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export const AppRouter: React.FC = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/try-free" element={<TryFreePage />} />
        <Route path="/register" element={<PublicOnlyRoute><RegisterPage /></PublicOnlyRoute>} />
        <Route path="/login" element={<PublicOnlyRoute><LoginPage /></PublicOnlyRoute>} />
        <Route path="/reset-password" element={<PublicOnlyRoute><PasswordResetRequestPage /></PublicOnlyRoute>} />
        <Route path="/reset-password/confirm" element={<PasswordResetConfirmPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/auth/callback" element={<AuthCallbackPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/terms" element={<TermsPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/cookies" element={<CookiesPage />} />
        <Route path="/accessibility" element={<AccessibilityPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/payment/success" element={<PaymentSuccessPage />} />
        <Route path="/payment/failed" element={<PaymentFailedPage />} />
        <Route path="/pass/success" element={<PassSuccessPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
        <Route path="/dashboard/subscription" element={<ProtectedRoute><SubscriptionPage /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
        <Route path="/exam-selection" element={<ProtectedRoute><ExamSelectionPage /></ProtectedRoute>} />
        <Route path="/pre-exam" element={<ProtectedRoute><PreExamSetupPage /></ProtectedRoute>} />
        <Route path="/exam-history" element={<ProtectedRoute><ExamHistoryPage /></ProtectedRoute>} />
        {/* Exam Runner Pages (trial-capable: an anonymous visitor with an attemptId may enter) */}
        <Route path="/exam/reading" element={<AttemptAccessRoute><ReadingExamPage /></AttemptAccessRoute>} />
        <Route path="/exam/listening" element={<AttemptAccessRoute><ListeningExamPage /></AttemptAccessRoute>} />
        <Route path="/exam/knm" element={<AttemptAccessRoute><KnmExamPage /></AttemptAccessRoute>} />
        <Route path="/exam/writing" element={<AttemptAccessRoute><WritingExamPage /></AttemptAccessRoute>} />
        <Route path="/exam/speaking" element={<AttemptAccessRoute><SpeakingExamPage /></AttemptAccessRoute>} />
        {/* Results & Review Pages (trial-capable: reached anonymously with an attemptId) */}
        <Route path="/results" element={<AttemptAccessRoute><ResultsPage /></AttemptAccessRoute>} />
        <Route path="/answer-review" element={<AttemptAccessRoute><AnswerReviewPage /></AttemptAccessRoute>} />
        {/* 404 Catch-all */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
};

export default AppRouter;
